export const FETCH_GET_LISTS = 'FETCH_GET_LISTS';
export const FETCH_CREATE_LIST = 'FETCH_CREATE_LIST';
export const FETCH_DELETE_LIST = 'FETCH_DELETE_LIST';
export const FETCH_EDIT_LIST = 'FETCH_EDIT_LIST';
export const SET_CREATE_LIST = 'SET_CREATE_LIST';
export const SET_ADD_LIST = 'SET_ADD_LIST';
export const SET_DELETE_LIST = 'SET_DELETE_LIST';
export const SET_EDIT_LIST = 'SET_EDIT_LIST';
